import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'http://localhost:8000/',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

export default {
  getBets() {
    return apiClient.get('/mock/bets')
  },
  getBetById(id) {
    return apiClient.get('/mock/bets/' + id)
  },
  createBet(user_email, bet) {
    console.log('bet created: ', bet)
    return apiClient.post('/bets/?user_email=' + user_email, bet)
  },
}
